import { Typography } from "@packages/ds";
import styled from "styled-components";

import { AddButton } from "ds/Button";
import * as Table from "ds/Table";

export const Add = styled(AddButton)`
  float: right;
`;

export const Wrapper = styled.div``;

export const Header = styled.div``;

export const Heading = styled(Typography.Title)`
  margin-bottom: 16px;
`;

export const Intro = styled(Typography.BodyText)`
  margin: 0 0 36px 0;
`;

export const Headers = styled.div`
  display: flex;
  margin-bottom: 12px;
  padding: 0 130px 0 36px;
`;

export const TableThead = styled(Table.Thead)`
  display: flex;
  margin-bottom: 12px;
  padding: 0 130px 0 36px;
`;

export const TableTh = styled(Table.Th)`
  flex: 1;
`;

export const HeaderItem = styled(Typography.BodyText)`
  flex: 1;
`;

export const Preview = styled.div<{ additionalMargin: boolean }>`
  display: flex;
  padding: 0 0 0 12px;
  margin-right: ${({ additionalMargin }) => (additionalMargin ? "32px" : 0)};
`;

export const Data = styled(Typography.BodyText)`
  flex: 1;
`;

export const Orders = styled.div`
  padding: 28px 4px 32px 4px;
`;

export const Order = styled.div`
  border-top: 1px solid var(--section-stone-border-color, var(--stone));
  display: flex;
  margin-left: 32px;
  padding: 16px 130px 16px 4px;
`;
